import { WHAT_IS_SOLIDAY_EURO_CARDS } from 'solidarity.module/common/domain/constants';

class WhatIsSolidaryListController {
  constructor() {
    this.cards = WHAT_IS_SOLIDAY_EURO_CARDS;
  }
}

export default WhatIsSolidaryListController;



// WEBPACK FOOTER //
// ./client/app/solidarity.module/components/whatIsSolidaryEuro/whatIsSolidaryList/whatIsSolidaryList.controller.js